import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { BASE_URL } from "../../../services/configUrls";
import { Tooltip } from "@mui/material";

const EditFacultyNameModal = ({ open, onClose, faculty, onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  //console.log("edu_id",faculty.faculty_id)
  // 🔔 Toast state
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success", // success | error
  });

  useEffect(() => {
    if (open && faculty) {
      setName(faculty.name ?? "");
    }
  }, [open, faculty]);

  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };

  const handleUpdate = async () => {
    if (!name.trim()) return;

    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/event/faculty/name`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          faculty_id: faculty.faculty_id,
          name: name.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || "Failed to update faculty name");
      }

      // ✅ Success toast
      setToast({
        open: true,
        message: data.message || "Faculty name updated successfully",
        severity: "success",
      });

      onSuccess(); // refresh table
      onClose(); // close modal
    } catch (error) {
      // ❌ Error toast
      setToast({
        open: true,
        message: error.message || "Something went wrong",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!faculty) return null;

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Edit Faculty Name</DialogTitle>

        <DialogContent>
          <TextField
            label="Faculty Name"
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mt: 2 }}
          />

          <TextField
            label="Email"
            fullWidth
            disabled
            value={faculty.email || ""}
            sx={{ mt: 2 }}
          />

          <TextField
            label="Designation"
            fullWidth
            disabled
            value={faculty.designation || ""}
            sx={{ mt: 2 }}
          />

          <Tooltip title={faculty.institute_name || ""}>
            <TextField
              label="Institute"
              fullWidth
              disabled
              value={faculty.institute_name || ""}
              sx={{
                mt: 2,
                "& .MuiInputBase-input": {
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                },
              }}
            />
          </Tooltip>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleUpdate}
            disabled={loading || !name.trim()}
          >
            {loading ? <CircularProgress size={22} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🔔 Toast Snackbar */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toast.severity}
          variant="filled"
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditFacultyNameModal;
